export default {
	accounts: {
		name: 'Konto | Konten',
		id: 'Konto-ID',
		journal: '@:entity.journal.name',
		approve_all_journals: 'Alle Buchungen geprüft',
		reject_all_journals: 'Alle Buchungen beanstanden',
		show_document: 'Dokument anzeigen',
		hide_document: 'Dokument ausblenden',
		default: 'Standard',
		reviews: 'Prüfungen',
		reviewed: 'geprüft',
		updated: 'aktualisiert',
		assign_reviewer: 'Prüfer festlegen',
		select_people_to_continue: 'Bitte markieren Sie Personen um fortzufahren',
		read: 'Lesend',
		write: 'Schreibend',
		accountingYear: 'Buchungsjahr',
		unit: 'VE',
		deeplink: {
			buildingAccountNotFound:
				'Das verlinkte Konto konnte in dieser Liegenschaft nicht gefunden werden. Möglicherweise wurde es entfernt.',
			accountNotFound: 'Das verlinkte Konto konnte in dieser Belegprüfung nicht gefunden werden. Möglicherweise wurde es entfernt.',
			loadingAccount:
				'Einen Moment, wir bringen Sie zum verlinkten Konto.',
			loadingJournal:
				'Einen Moment, wir bringen Sie zur verlinkten Buchung.',
			journalNotFound: 'Die verlinkte Buchung konnte in diesem Konto nicht gefunden werden. Möglicherweise wurde sie entfernt.',
			fromNotification: 'Aus Ihrer Benachrichtigung',
			contraAccountNotInReview:
				'Das Gegenkonto gehört nicht zu dieser Belegprüfung. Sie finden es in der Buchhaltung der Liegenschaft.',
			jumpToContraAccount: 'Zum Gegenkonto springen',
			returnFromJournalHint: 'Sie sind von einer Buchung hierher gesprungen.',
			returnFromJournal: 'Zurück zur Buchung',
			returnFromInvoiceHint: 'Sie sind von einer Rechnung hierher gesprungen.',
			returnFromInvoice: 'Zurück zur Rechnung',
		},
	},
}
